import { filter } from 'rxjs/operators';
import * as  RoleActions from './roles.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { Role } from '@kion/data-models';

export const ROLES_FEATURE_KEY = 'role';

export interface RolesState extends EntityState<Role> {
  error?: any;
  lastCreatedId: string|null;

  isSearching: boolean;
  searchResultIds: string[];
}

export const adapter: EntityAdapter<Role> = createEntityAdapter<Role>();

export interface RolesPartialState {
  readonly [ROLES_FEATURE_KEY]: RolesState;
}

export const initialState: RolesState = adapter.getInitialState({
  lastCreatedId: null,
  isSearching: false,
  searchResultIds: [],
  searchQuery: {},
  pagination: {
    page: 1,
    perPage: 10,
    totalPages: 0,
    count: 0,
    total: 0
  }
});

const RolesReducer = createReducer(
  initialState,
  on(
    RoleActions.setRolesSuccess,
    RoleActions.loadByUserIdSuccess,
    (state, { roles  }) => adapter.upsertMany(roles , { ...state })
  ),
  on(
    RoleActions.revokeRolesSuccess,
    (state, { roles  }) => adapter.removeMany(roles.map(role => role.id), {...state})
  ),
  on(
    RoleActions.removeUnusedRolesFromUser,
    (state, { roles  }) => {
      const currentUserRoleIds : string[] = [] ;
      for(let [key, value] of Object.entries(state.entities)) {
        currentUserRoleIds.push(key)
      }
      const newUserRoleIds : string[] = roles.map(role => role.id) ;

      return adapter.removeMany(
        currentUserRoleIds.filter(roleId => !newUserRoleIds.find(id => id === roleId)),
        {...state}
      )
      // return adapter.removeMany([], {...state});
    }
  )
);

export function reducer(
  state: RolesState | undefined,
  action: Action
) {
  return RolesReducer(state, action);
}
